/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountDataRetentionInDaysQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountDataRetentionInDaysQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly dataRetentionInDays: number } | null };


export const AccountDataRetentionInDaysDocument = gql`
    query AccountDataRetentionInDays($accountId: AccountId!) {
  account(id: $accountId) {
    id
    dataRetentionInDays
  }
}
    `;

/**
 * __useAccountDataRetentionInDaysQuery__
 *
 * To run a query within a React component, call `useAccountDataRetentionInDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDataRetentionInDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDataRetentionInDaysQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountDataRetentionInDaysQuery(baseOptions: Apollo.QueryHookOptions<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables> & ({ variables: AccountDataRetentionInDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables>(AccountDataRetentionInDaysDocument, options);
      }
export function useAccountDataRetentionInDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables>(AccountDataRetentionInDaysDocument, options);
        }
export function useAccountDataRetentionInDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables>(AccountDataRetentionInDaysDocument, options);
        }
export type AccountDataRetentionInDaysQueryHookResult = ReturnType<typeof useAccountDataRetentionInDaysQuery>;
export type AccountDataRetentionInDaysLazyQueryHookResult = ReturnType<typeof useAccountDataRetentionInDaysLazyQuery>;
export type AccountDataRetentionInDaysSuspenseQueryHookResult = ReturnType<typeof useAccountDataRetentionInDaysSuspenseQuery>;
export type AccountDataRetentionInDaysQueryResult = Apollo.QueryResult<AccountDataRetentionInDaysQuery, AccountDataRetentionInDaysQueryVariables>;